"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const index_1 = require("../../index");
const Icon_1 = __importDefault(require("../Icon/Icon"));
const Checkbox_1 = __importDefault(require("./Checkbox"));
const ExpandableCheckbox = ({ checked, indeterminate, onChange, id, label, children, truncated = false, hoverButton, onBlur, name, value, openOnInit, disabled, showNumberOfChildren = true, }) => {
    const [open, setOpen] = React.useState(openOnInit !== undefined ? openOnInit : false);
    const numberOfChildren = React.Children.count(children);
    const toggleOpen = () => setOpen(!open);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "parent-checkbox-wrapper" },
            React.createElement(Checkbox_1.default, { checked: checked, indeterminate: indeterminate, id: id, onChange: onChange, label: label, truncated: truncated, onBlur: onBlur, name: name, value: value, disabled: disabled }),
            React.createElement("span", { className: "checkbox-children-number" }, showNumberOfChildren ? `(${numberOfChildren})` : ''),
            React.createElement("button", { type: "button", onClick: toggleOpen, className: "toggle-icon" },
                React.createElement(Icon_1.default, { icon: open ? 'arrow_up' : 'arrow_down' })),
            hoverButton && React.createElement(index_1.Button, { size: "xs", onClick: hoverButton.action }, hoverButton.label)),
        renderBody()));
    function renderBody() {
        if (!open) {
            return null;
        }
        return (React.createElement("div", { className: "parent-checkbox-body" }, children));
    }
};
exports.default = ExpandableCheckbox;
//# sourceMappingURL=ExpandableCheckbox.js.map